import React, { useState } from 'react';
import { Info, ExternalLink, ChevronDown, ChevronUp } from 'lucide-react';
import { NIPR_URL, NIPR_STEPS } from '../../../../lib/producerPage.js';

/**
 * "Need help finding your official licenses?" — where to look up and print a license certificate.
 * @param {{defaultOpen?: boolean}} props
 */
export default function NiprGuide({ defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="rounded-lg border border-sky-500/30 bg-sky-500/5 p-4" data-testid="nipr-guide">
      <div className="flex items-start gap-2">
        <Info className="mt-0.5 h-4 w-4 shrink-0 text-sky-300" />
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold text-white">Need help finding your official licenses?</div>
          <p className="mt-0.5 text-xs text-white/70">
            Look up your license status and print copies at the{' '}
            <a href={NIPR_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-0.5 text-sky-300 underline" data-testid="nipr-link">
              NIPR Licensing Center <ExternalLink className="h-3 w-3" />
            </a>.
          </p>
          <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} data-testid="nipr-toggle" className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-sky-200 hover:text-white">
            {open ? <>Hide the steps <ChevronUp className="h-3.5 w-3.5" /></> : <>Show the 5 steps <ChevronDown className="h-3.5 w-3.5" /></>}
          </button>
          {open && (
            <ol className="mt-2 list-decimal space-y-1 pl-5 text-xs text-white/75" data-testid="nipr-steps">
              {NIPR_STEPS.map((step) => <li key={step}>{step}</li>)}
            </ol>
          )}
        </div>
      </div>
    </div>
  );
}
